'use client';

import React from 'react';
import { Slide } from '@/shared/types';
import { GlobeIcon } from '@phosphor-icons/react';

// Interfaces and types
interface LocationPaneProps {
  slide: Slide;
}

// Component definition
const LocationPane: React.FC<LocationPaneProps> = ({
  slide
}) => {
  // Initialize state
  return <div className='slide-boxes mini text-white' data-sentry-component="LocationPane" data-sentry-source-file="locationPane.tsx">
      <GlobeIcon weight="duotone" className='w-4 h-4' data-sentry-element="GlobeIcon" data-sentry-source-file="locationPane.tsx" />
      <span>{slide.location?.name || slide.location?.address}</span>
    </div>;
};
export default LocationPane;